import type { Translation } from "../../../../hooks/useTranslations";

/** The label of each lateral resistance configuration, by its numeric id (0 column notch … 4 lock stop). */
export const lateralResistanceLabels = (t: Translation): Record<number, string> => {
  const labels = t.lockCalculatorModule.structural.lateralResistance;
  return {
    0: labels.columnNotch,
    1: labels.headerBeamNotch,
    2: labels.joistBeamNotch,
    3: labels.inclinedFasteners,
    4: labels.lockstop,
  };
};

/** The label of each header orientation. */
export const headerOrientationLabels = (t: Translation): Record<"beam" | "column", string> => {
  const labels = t.lockCalculatorModule.structural.headerOrientationOptions;
  return { beam: labels.beam, column: labels.column };
};
